import { FC, ReactElement, useState } from "react";
import { Box, Dialog, IconButton, Stack, Typography } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";

import { ContainedButton } from "@/common";
import { useSnackbar } from "@/hooks";
import { featured_delete_icon } from "@/constants";

interface IDeleteConfirmModal {
  open: boolean;
  setOpen?: (open: boolean) => void;
  noPadding?: boolean;
  hideClose?: boolean;
  itemName?: string;
  onClose: () => void;
  onConfirm?: () => Promise<void>;
  maxWidth: "xs" | "sm" | "md" | "lg" | "xl";
  subText?: string;
  btnLoader?: boolean;
}

const DeleteConfirmModal: FC<IDeleteConfirmModal> = ({
  open,
  onClose,
  noPadding,
  maxWidth,
  itemName,
  setOpen,
  onConfirm,
  subText,
  btnLoader,
}): ReactElement => {
  const { show } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const handleClose = (): void => {
    if (!isLoading) {
      if (setOpen) {
        setOpen(false);
      }
    }
  };
  const handleSubmit = (): void => {
    if (onConfirm) {
      setIsLoading(true);
      onConfirm().then(() => {
        setIsLoading(false);
        show("Deleted Successfully!", "", "success");
        handleClose();
      });
    } else {
      handleClose();
    }
  };
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth
      sx={{
        background: "rgba(97, 101, 106, 0.8)",
        ".MuiDialog-paper": {
          padding: noPadding ? "0rem" : "1.7rem",
          "::-webkit-scrollbar": { width: "0" },
        },
        div: {
          borderRadius: "10px",
        },
      }}
    >
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <img src={featured_delete_icon} alt="featured delete icon" width={50} />
        <IconButton onClick={onClose}>
          <CloseIcon fontSize="large" />
        </IconButton>
      </Box>
      <Box>
        {" "}
        <Box my={2}>
          <Typography fontSize={20} noWrap fontWeight={500}>
            Delete {itemName}
          </Typography>
          <Typography fontSize={15} color={"#8C8E9C"} fontWeight={400}>
            Are you sure you want to delete this {subText}? This action cannot
            be undone.
          </Typography>
        </Box>
        <Stack spacing={2} direction={"row"} pt={3}>
          <ContainedButton
            title="Close"
            size="large"
            onClick={onClose}
            sx={{
              border: "1px solid #E6E6E9",
              flex: "1",
              color: "black",
              boxShadow:
                "0px 1px 3px 0px rgba(16, 24, 32, 0.05), 0px 23px 44px 0px rgba(16, 24, 32, 0.05)",
            }}
            variant="white-contained"
          />
          <ContainedButton
            size="large"
            disabled={btnLoader}
            title={btnLoader ? "Please Wait..." : "Confirm"}
            color="error"
            onClick={handleSubmit}
            sx={{ flex: 1, color: "#FFFFFF" }}
          />
        </Stack>
      </Box>
    </Dialog>
  );
};

export default DeleteConfirmModal;
